import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import { Box } from '@shared/components/Box'

import styles from './TransactionSuccessDialogueTemplate.module.scss'

interface TransactionFailedDialogueTemplateProps {
  title: string
  goBack?(): void
}

export const TransactionFailedDialogueTemplate: React.FunctionComponent<
  PropsWithChildren<TransactionFailedDialogueTemplateProps>
> = (props) => {
  const { children, title, goBack } = props

  return (
    <FailedDialogueTemplate title={title} goBack={goBack}>
      {children}
    </FailedDialogueTemplate>
  )
}

const FailedDialogueTemplate: React.FunctionComponent<
  PropsWithChildren<TransactionFailedDialogueTemplateProps>
> = ({ children, title, goBack = () => {} }) => {
  const { t } = useTranslation()

  return (
    <Box flex align='center' justify='center' fullWidth fullHeight mt='x32' alignSelf='center'>
      <Box
        className={styles.box}
        flex
        textAlign='center'
        direction='column'
        align='center'
        radius='x12'
        p='x24'
        gap='x16'
      >
        <Heading6 className='has-text-centered' medium>
          {title}
        </Heading6>
        <Box flex align='center' direction='column'>
          {children}
        </Box>
        {goBack && (
          <Button.Primary fullWidth size='lg' onClick={goBack}>
            {t('OK')}
          </Button.Primary>
        )}
      </Box>
    </Box>
  )
}
